import React, { Component } from 'react'
import './_styles.scss'
import { Button } from 'src/packages/components/lib/Button'
import Asset from '../../../../../requests/apa/Asset'
import { animationDuration } from '../../../constants'
import { getPhase2Config } from '../../../utils'

const getIcons = () => ({
  right: {
    normal: Asset.get('eventodeportivo_icono_chevronderecho_default', ''),
    focus: Asset.get('eventodeportivo_icono_chevronderecho_foco', '')
  },
  left: {
    normal: Asset.get('eventodeportivo_icono_chevronizquierdo_default', ''),
    focus: Asset.get('eventodeportivo_icono_chevronizquierdo_foco', '')
  }
})

/**
 * Chevron
 * Circular navigation arrow button (64x64px from Figma)
 *
 * Props:
 *  - direction  {'left'|'right'}  Arrow direction
 *  - onClick    {function}        Click / select handler
 *  - isFocused  {bool}            TV focus state
 */
class Chevron extends Component {
  constructor (props) {
    super(props)
    this.isPhase2Enabled = getPhase2Config()
    this.state = {
      icons: null,
      isFocused: false
    }
  }

  componentDidMount(){
    const icons = getIcons()
    const dir = this.props.direction === 'right' ? 'right' : 'left'
    this._preloadedImages = Object.values(icons[dir]).map(src => {
      const img = new Image()
      img.src = src
      return img
    })

    this.setState({ icons })
  }

  handleFocus = () => {
    this.setState({ isFocused: true })
  }

  handleBlur = () => {
    this.setState({ isFocused: false })
  }

  handleClick = () => {
    const { onClick } = this.props
    if (onClick) onClick()

    setTimeout(() => {
      const card = document.querySelector('.card-partido.focusable') ||
                   document.querySelector('.card-partido-square.focusable')
      if (card) card.focus()
    }, animationDuration)
  }

  render () {
    const { direction, dataOptions } = this.props
    const { icons, isFocused } = this.state
    const isRight = direction === 'right'
    const dir = isRight ? 'right' : 'left'
    let iconSrc = ''
    if (icons) {
      iconSrc = isFocused ? icons[dir].focus : icons[dir].normal
    }

    return (
      <Button
        className={[
          'chevron',
          this.isPhase2Enabled ? 'chevron--nonfocusable' : 'chevron--focusable',
          isRight ? 'chevron--right' : 'chevron--left',
          'focusable'
        ].filter(Boolean).join(' ')}
        onFocus={e => {
          if (!this.isPhase2Enabled) this.handleFocus()
          if (this.isPhase2Enabled) this.handleClick()
        }}
        onBlur={!this.isPhase2Enabled && this.handleBlur}
        onClick={this.isPhase2Enabled ? null : this.handleClick}
        dataOptions={dataOptions}
      >
        <img
          className='chevron__icon'
          src={iconSrc}
          alt={isRight ? 'chevron derecho' : 'chevron izquierdo'}
        />
      </Button>
    )
  }
}

export default Chevron



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Partidos/Components/Chevron/index.jsx